module.exports = __webpack_public_path__ + "img/9.71a6aea4.png";